import React from "react";

import { validateEmail } from "../../../../lib/utils";
import AuthService, {
  PermissionClaims,
} from "../../../../services/AuthService";

import GeneralInfo from "./GeneralInfo";
import AddressInfo from "./AddressInfo";
import SchoolsInfo from "./SchoolsInfo";
import ContactInfo from "./ContactInfo";
import ShluchimInfo from "./ShluchimInfo";
import PersonnelInfo from "./PersonnelInfo";

export default class GeneralForm extends React.PureComponent {
  require = (value) => (!value && value !== false && value !== 0 ? true : "");

  hasUSAddress = (address) => address && address.country === "USA";

  validateDemographics = (value) => {
    if (value.length < 1) return true;
  };

  validateContactMethod = (value, contactMethod) => {
    if (!value) return true;
    if (contactMethod.type === "Email") {
      return !validateEmail(value) ? "Invalid Email" : "";
    }
  };

  render() {
    const {
      campuses,
      errors,
      handleChange,
      setFieldValue,
      setFieldError,
      sys,
      touched,
      shliachID,
      initialValues,
      values,
    } = this.props;

    const hasConfigsEditPermission = AuthService.UserHasClaim(
      PermissionClaims.ConfigsEdit,
    );

    return (
      <div className="profile-form-sections">
        {hasConfigsEditPermission && (
          <div className="profile-form-section with-divider">
            <label className="flex flex-align-center">
              <input
                type="checkbox"
                name="hideFromPublicDirectory"
                checked={!!values.hideFromPublicDirectory}
                onChange={handleChange}
                style={{ marginRight: "8px" }}
              />
              Hide from public directory
            </label>
            <p className="accent-text small-text mt-8">
              This hides the Chabad House from the public directory. Archived
              state is not affected. Changes may take a few minutes to reflect
              on the public directory.
            </p>
          </div>
        )}
        <div className="profile-form-section">
          <p className="accent-text small-text line-height-double">
            Review and edit general Chabad House information. This information
            will be displayed on the public directory @
            chabadoncampus.org/directory.
          </p>
        </div>
        <GeneralInfo
          errors={errors}
          hasUSAddress={this.hasUSAddress}
          require={this.require}
          setFieldValue={setFieldValue}
          sys={sys}
          touched={touched}
          initialValues={initialValues}
          values={values}
          handleChange={handleChange}
          validateDemographics={this.validateDemographics}
        />
        <AddressInfo
          errors={errors}
          handleChange={handleChange}
          hasUSAddress={this.hasUSAddress}
          require={this.require}
          setFieldValue={setFieldValue}
          sys={sys}
          touched={touched}
          shliachID={shliachID}
          values={values}
        />
        <SchoolsInfo
          campuses={campuses}
          errors={errors}
          handleChange={handleChange}
          require={this.require}
          setFieldValue={setFieldValue}
          sys={sys}
          touched={touched}
          values={values}
        />
        <ContactInfo
          errors={errors}
          require={this.require}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          sys={sys}
          touched={touched}
          values={values}
          validateContactMethod={this.validateContactMethod}
        />
        {/* TODO redo social info */}
        {/* <SocialInfo errors={errors} require={this.require} touched={touched} /> */}
        <ShluchimInfo
          errors={errors}
          require={this.require}
          setFieldValue={setFieldValue}
          touched={touched}
          values={values}
          sys={sys}
        />
        <PersonnelInfo
          errors={errors}
          require={this.require}
          setFieldValue={setFieldValue}
          touched={touched}
          values={values}
          sys={sys}
        />
      </div>
    );
  }
}
